// extracted by mini-css-extract-plugin
export default {"wrapper":"wx-z","viewport":"xx-z","container":"yx-z","slide":"zx-z"};